import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { CTASection } from './components/CTASection';
import { ReferencesSection } from './components/ReferencesSection';
import { ContactSection } from './components/ContactSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { GalleryPage } from './pages/GalleryPage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { SEO } from './components/SEO';

const HomePage = () => (
  <>
    <SEO 
      title=""
      description="MP Frankendach: Ihr zuverlässiger Dachdecker-Meisterbetrieb in Fürth. Professionelle Dachsanierung, Fassadenarbeiten und Abdichtung mit über 10 Jahren Erfahrung. Jetzt kostenlos beraten lassen!"
      keywords="Dachdecker Fürth, Dachsanierung Nürnberg, Fassadenarbeiten, Abdichtung, Meisterbetrieb, Dachdeckerarbeiten, MP Frankendach"
      canonical="https://mp-frankendach.de/"
    />
    <Header />
    <HeroSection />
    <AboutSection />
    <ServicesSection />
    <CTASection />
    <ReferencesSection />
    <ContactSection />
    <FAQSection />
    <Footer />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/galerie" element={<GalleryPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;